import React from "react"
import Layout from "@yumgmbh/gatsby-theme-yum-components/src/components/modules/Layout"
import SEO from "@yumgmbh/gatsby-theme-yum-components/src/components/modules/Seo"
import BodyBlocks from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BodyBlocks"
import CardsBlock from "@yumgmbh/gatsby-theme-yum-components/src/components/blocks/CardsBlock"
import KoinnoBannerBlock from "../blocks/KoinnoBannerBlock"

const StartPage = ({ content }) => {
  return (
    <Layout>
      <SEO title={content.headline}></SEO>
      <CardsBlock
        block={{
          show_slides: 3,
          view: "slider",
          // headline: "Weitere News",
          card_items: [
            {
              image: {
                filename:
                  "https://a.storyblok.com/f/104752/1824x1368/9624bce6a4/yum_test_bild.jpg",
              },
              link: "",
              kicker: "12.04.2021 - Politik & Wirtschaft",
              headline: "News Nr. 2",
              text: "Bundeswirtschaftsminister Altmaier: „Die Industrie- und Exportland Deutschland braucht eine sichere, nachhaltige und verantwortungsvolle Rohstoffversorgung.“",
              link_text: "Weiterlesen",
            },
            {
              image: {
                filename:
                  "https://a.storyblok.com/f/104752/1824x1368/9624bce6a4/yum_test_bild.jpg",
              },
              link: "",
              kicker: "12.04.2021 - Politik & Wirtschaft",
              headline: "News Nr. 3",
              text: "Bundeswirtschaftsminister Altmaier: „Die Industrie- und Exportland Deutschland braucht eine sichere, nachhaltige und verantwortungsvolle Rohstoffversorgung.“",
              link_text: "Weiterlesen",
            },
            {
              image: {
                filename:
                  "https://a.storyblok.com/f/104752/1824x1368/9624bce6a4/yum_test_bild.jpg",
              },
              link: "",
              kicker: "12.04.2021 - Politik & Wirtschaft",
              headline: "News Nr. 4",
              text: "Bundeswirtschaftsminister Altmaier: „Die Industrie- und Exportland Deutschland braucht eine sichere, nachhaltige und verantwortungsvolle Rohstoffversorgung.“",
              link_text: "Weiterlesen",
            },
            {
              image: {
                filename:
                  "https://a.storyblok.com/f/104752/1824x1368/9624bce6a4/yum_test_bild.jpg",
              },
              link: "",
              kicker: "12.04.2021 - Politik & Wirtschaft",
              headline: "News Nr. 5",
              text: "Bundeswirtschaftsminister Altmaier: „Die Industrie- und Exportland Deutschland braucht eine sichere, nachhaltige und verantwortungsvolle Rohstoffversorgung.“",
              link_text: "Weiterlesen",
            },
          ],
        }}
      />
      <BodyBlocks body={content.body} />
      <KoinnoBannerBlock />
    </Layout>
  )
}

export default StartPage
